export class SignalCssClasses {
	static mdiWifiStrength4 = "mdi-wifi-strength-4";
	static mdiWifiStrength3 = "mdi-wifi-strength-3";
	static mdiWifiStrength2 = "mdi-wifi-strength-2";
	static mdiWifiStrength1 = "mdi-wifi-strength-1";
	static mdiWifiStrengthAlertOutline = "mdi-wifi-strength-alert-outline";
}